/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Theme functions
window.theme = window.theme || {};

theme.cacheSelectors = function () {
  theme.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

theme.init = function () {
  theme.searchBar();
  theme.Fade();
  theme.ScrollTop();
  theme.mobileFooter();
  theme.accordionTabs();
  theme.slideShow();
  theme.stickyNav();
  FastClick.attach(document.body);
  theme.cacheSelectors();
  theme.accessibleNav();
  theme.drawersInit();
  theme.mobileNavToggle();
  theme.productImageSwitch();
  theme.responsiveVideos();
  theme.collectionViews();
  theme.loginForms();
  theme.featuredProductsSlider();
  theme.testimonialSlider();
  theme.singleProductSlider();
  theme.collectionFilter();
  theme.productrowsZoom();
  theme.readMore();
  theme.dialogPopup();
};

theme.accessibleNav = function () {
  var $nav = theme.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      theme.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    theme.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

theme.drawersInit = function () {
  theme.LeftDrawer = new theme.Drawers('NavDrawer', 'left');
  
    theme.RightDrawer = new theme.Drawers('CartDrawer', 'right', {
      'onDrawerOpen': ajaxCart.load
    });
  
};

theme.mobileNavToggle = function () {
  theme.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

theme.getHash = function () {
  return window.location.hash;
};

theme.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $productImageFeature = $('.js-single-main'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $saveAmount = $('#SaveAmount'),
      $savePrice = $('#save-price'), 
      $addToCartText = $('#AddToCartText'),
      $purchaseType = $("input[type='radio'][name='purchase_type']");

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, theme.switchImage);

      const thumbIndex = variant.featured_image.position - 1;
      const tempSwiper = new Swiper($productImageFeature, {
        fadeEffect: {
          crossFade: true
        },
        effect: 'fade'
      });
      tempSwiper.slideTo(thumbIndex, 900);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to Cart");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price >= variant.price) {
      
      // Change product type (subscription / onetime)
      $("input[type='radio'][name='purchase_type']").click(function() {
        var value = $(this).val();
        if (value === 'autodeliver') {
          $saveAmount.html(Shopify.formatMoney((variant.compare_at_price - (variant.price - variant.price * 0.25)), moneyFormat));
        } else {
          $saveAmount.html(Shopify.formatMoney((variant.compare_at_price - variant.price), moneyFormat));
        }
      });

      
      $comparePrice
        .html(" " + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();

      if ($("input[type='radio'][name='purchase_type']:checked").val() === 'autodeliver') {
      	$saveAmount.html(Shopify.formatMoney((variant.compare_at_price - (variant.price - variant.price * 0.25)), moneyFormat));
      } else {
      	$saveAmount.html(Shopify.formatMoney((variant.compare_at_price - variant.price), moneyFormat));
      }

    } else {
      $savePrice.hide();
      $comparePrice.hide();
    }
  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
  

};

theme.productImageSwitch = function () {
  if (theme.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    theme.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      theme.switchImage(newImage, null, theme.cache.$productImage);
    });
  }
};

theme.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

theme.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

theme.collectionViews = function () {
  if (theme.cache.$changeView.length) {
    theme.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

theme.loginForms = function() {
  function showRecoverPasswordForm() {
    theme.cache.$recoverPasswordForm.show();
    theme.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    theme.cache.$recoverPasswordForm.hide();
    theme.cache.$customerLoginForm.show();
  }

  theme.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  theme.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (theme.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

theme.resetPasswordSuccess = function() {
  theme.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Fade content modules
==============================================================================*/
theme.Fade = (function () {
  window.onload = function () {
    $('body').css("opacity", "1");
  }
});

/*============================================================================
  Scroll To Top
==============================================================================*/
theme.ScrollTop = (function () {
  const btnTop = document.querySelector('#js-top');

  const scrollToTop = () => {
    const c = document.documentElement.scrollTop || document.body.scrollTop;

    if (c > 0) {
      window.requestAnimationFrame(scrollToTop);
      window.scrollTo(0, c - c / 20);
    }
  };

  btnTop.onclick = function (e) {
    e.preventDefault();
    scrollToTop();
  }
});

/*============================================================================
  Mobile Footer
==============================================================================*/
theme.mobileFooter = (function () {
  $(".site-footer__column > h3 > .mobile-clicker").click(function () {
    const $this = $(this).parents(".site-footer__column");
    $this.siblings().removeClass("open");

    if ($this.hasClass("open")) {
      $this.removeClass("open");
    } else {
      $this.addClass("open");
    }
  });
});

/*============================================================================
  Accordion
==============================================================================*/
theme.accordionTabs = (function () {
  $('.accordion').each(function () {
    const $this = $(this);

    if ($this.length) {
      $this.accordion({
        "transitionSpeed": 300,
        "singleOpenis" : true
      });
    }
  }); 
});

/*============================================================================
  Header Search Bar
==============================================================================*/
theme.searchBar = (function () {
  $(document).on('click', function (e) {
    if ($(e.target).closest('.site-header__search-trigger').length) {
      $('.site-header__search').slideToggle();
      $(".site-header__search input[type='search']").focus();
    } else if (!$(e.target).closest('.site-header__search').length) {
      $('.site-header__search').hide();
    }
  });
});

/*============================================================================
  Header Sticky
==============================================================================*/
theme.stickyNav = (function () {
  let isTransparent = true;
  const header = document.querySelector('.site-header');
  const headerHeight = header.offsetHeight;

  window.addEventListener('scroll', event => {
    if (window.pageYOffset > headerHeight && isTransparent){
      header.classList.add('isStuck');
      isTransparent = false;
    }

    if (window.pageYOffset <= headerHeight && !isTransparent) {
      header.classList.remove('isStuck');
      isTransparent = true;
    }
  });

});

/*============================================================================
  Dialog popup 
==============================================================================*/
theme.dialogPopup = function () {
  $('.zoom-dialog-trigger').each(function () {
    const $this = $(this);

    if ($this.length) {
      $this.magnificPopup({
        items: {
          src: '.zoom-dialog',
          type: 'inline',
        },

		fixedContentPos: false,
		fixedBgPos: true,

		overflowY: 'auto',

		closeBtnInside: true,
		preloader: false,
		
		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in'
      });
    }
  });
}

/*============================================================================
  Product Rows Zoom 
==============================================================================*/
theme.productrowsZoom = function () {
  $('.feature-row__image .image-zoom').each(function () {
    const $this = $(this);

    if ($this.length) {
      $this.magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        closeBtnInside: false,
        fixedContentPos: true,
        mainClass: 'mfp-no-margins mfp-with-zoom js-featured-image row-featured__image',
        image: {
          verticalFit: true
        },
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0,1]
        },
        zoom: {
          enabled: true,
          duration: 300
        }
      });
    }
  });
}

/*============================================================================
  Growing Number
==============================================================================*/
theme.countNumber = function () {
  $('.counting-number').each(function () {
    const $this = $(this);

    if ($this.length) {
      var a = 0;
      $(window).scroll(function() {
        var oTop = $('.counting-number').offset().top - window.innerHeight;
        if (a == 0 && $(window).scrollTop() > oTop) {
          $('.counting-number').each(function() {
            var $this = $(this),
                countTo = $this.attr('data-count');
            $({
              countNum: $this.text()
            }).animate({
              countNum: countTo
            },

                       {

              duration: 3000,
              easing: 'linear',
              step: function() {
                $this.text(Math.floor(this.countNum));
              },
              complete: function() {
                $this.text(this.countNum).toLocaleString();
              }

            });
          });
          a = 1;
        }
      });

    }
  });
}

/*============================================================================
  Read More Content
==============================================================================*/
theme.readMore = function () {
  $('.readmore-content').each(function () {
    const $this = $(this);
    $this.readmore({
      speed: 300,
      moreLink: '<button class="btn">Read more +</button>',
      lessLink: '<button class="btn">Read less -</button>'
    });
  });
}

/*============================================================================
  Collection Filter
==============================================================================*/
theme.collectionFilter = function () {
  // toggle filter content
  $('#collection-tags__filter .group-title').each(function () {
    $(this).click(function () {
      if ($(this).hasClass('active')) {
        $('#collection-tags__filter .filter-content').removeClass('active');
        $('#collection-tags__filter .group-title').removeClass('active');
        $('#collection-tags__filter').removeClass('active');
      } else {
        $('#collection-tags__filter .filter-content').removeClass('active');
        $('#collection-tags__filter .group-title').removeClass('active');
        $(this).next('.filter-content').addClass('active');
        $(this).addClass('active');
        $('#collection-tags__filter').addClass('active');
      }
      event.stopPropagation();
    });

    if ($(window).width() > 768) {
      $(document).click(function () {
        $('#collection-tags__filter .filter-content').removeClass('active');
        $('#collection-tags__filter .group-title').removeClass('active');
        $('#collection-tags__filter').removeClass('active');
      });
    }
  });

  if ($(window).width() < 769) {
    $('#collection-tags__filter .filter-tag-groups .tag-group:first-child .filter-content').addClass('active');
    $('#collection-tags__filter .filter-tag-groups .tag-group:first-child .group-title').addClass('active');
  }

  // filter mobile
  $('#collection-tags__filter-trigger').click(function () {
    $('#collection-tags__filter').toggleClass('open');
  });
  $('#collection-tags__filter .filter-header').click(function () {
    $('#collection-tags__filter').removeClass('open');
  });

  // ajax filter
  $("#collection-tags__filter ul.swatch-list li a, #collection-tags__filter .filter-content__footer .current-tags .tag a, #collection-tags__filter .clear-tag-btn").each(function () {
    $(this).click(function (event) {
      event.preventDefault();
      var url = $(this).attr('href');
      $.ajax({
        type: 'GET',
        url: url,
        data: {},
        beforeSend: function (xhr) {
          $("#collection-tags__load").show();
        },
        complete: function (data) {
          $('#collection-content').html($("#collection-content", data.responseText).html());
          history.pushState({
            page: url
          }, url, url);
          theme.collectionFilter();
          $("#collection-tags__load").hide();
          $.magnificPopup.close();
        }
      });
    });
  });
};


/*============================================================================
  Main Slideshow
==============================================================================*/
theme.slideShow = (function () {
  $('.js-slideshow').each(function (index, element) {
    const $this = $(this);
    const settings = {
      prevArrow:  $this.find('.swiper-button-prev'),
      nextArrow: $this.find('.swiper-button-next')
    }

    if ($this.length) {
      //initiate the slideshow
      const featuredProduct = new Swiper($this, {
        spaceBetween: 30,
        effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },

        // Navigation arrows
        navigation: {
          nextEl: settings.nextArrow,
          prevEl: settings.prevArrow,
        },

        // And if we need scrollbar
        scrollbar: false,
        mousewheel: {
          forceToAxis: true,
        },
        //cssMode: true,
        freeMode: true
      })
    }
  })
});

/*============================================================================
  Featured Products Slider
==============================================================================*/
theme.featuredProductsSlider = (function () {
  $('.js-featured-products').each(function (index, element) {
    const $this = $(this);
    const settings = {
      slidesPerView: $this.data('slides'),
      spaceBetween: $this.data('space'),
      sliderNav: $this.data('nav'),
      sliderLoop: $this.data('loop'),
      prevArrow: $this.parent().find('.swiper-button-prev'),
      nextArrow: $this.parent().find('.swiper-button-next'),
      sliderScrollBar: $this.find('.swiper-scrollbar')
    }

    if ($this.length) {
      //initiate the slideshow
      const featuredProduct = new Swiper($this, {
        // Optional parameters
        preventClicks: false,
        preventClicksPropagation: false,
        speed: 600,
        loop: settings.sliderLoop,
        direction: 'horizontal',

        slidesPerView: settings.slidesPerView,
        spaceBetween: settings.spaceBetween,

        // Navigation arrows
        navigation: {
          nextEl: settings.nextArrow,
          prevEl: settings.prevArrow,
        },

        // And if we need scrollbar
        scrollbar: {
          el: settings.sliderScrollBar,
          draggable: true,
          snapOnRelease: true
        },
        mousewheel: {
          forceToAxis: true,
        },
        //cssMode: true,
        freeMode: true,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 2,
            spaceBetween: 10,
            navigation: false,
            freeMode: false
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 2,
            spaceBetween: 10,
            navigation: false,
            freeMode: false
          },
          // when window width is >= 640px
          640: {
            slidesPerView: settings.slidesPerView,
            spaceBetween: settings.spaceBetween,
            freeMode: true
          }
        }
      })
    }
  })
});

/*============================================================================
  Testimonials Slider
==============================================================================*/
theme.testimonialSlider = (function () {
  $('.js-testimonials').each(function (index, element) {
    const $this = $(this);
    const settings = {
      slidesPerView: $this.data('slides'),
      spaceBetween: $this.data('space'),
      sliderNav: $this.data('nav'),
      sliderLoop: $this.data('loop'),
      sliderAutoplay: $this.data('autoplay'),
      prevArrow: $this.parent().find('.swiper-button-prev'),
      nextArrow: $this.parent().find('.swiper-button-next'),
      sliderScrollBar: $this.find('.swiper-scrollbar')
    }

    if ($this.length) {
      //initiate the slideshow
      const testimonialSlider = new Swiper($this, {
        // Optional parameters
        preventClicks: false,
        preventClicksPropagation: false,
        speed: 600,
        effect: 'fade',
        autoHeight: true,
        loop: settings.sliderLoop,
        direction: 'horizontal',
        autoplay: settings.sliderAutoplay,

        slidesPerView: settings.slidesPerView,
        spaceBetween: settings.spaceBetween,

        // Navigation arrows
        navigation: {
          nextEl: settings.nextArrow,
          prevEl: settings.prevArrow,
        },

        // And if we need scrollbar
        scrollbar: {
          el: settings.sliderScrollBar,
          draggable: true,
          snapOnRelease: true
        },
        mousewheel: {
          forceToAxis: true,
        },
        //cssMode: true,
        freeMode: false,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: false,
            freeMode: false
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: false,
            freeMode: false
          },
          // when window width is >= 640px
          640: {
            slidesPerView: settings.slidesPerView,
            spaceBetween: settings.spaceBetween,
            freeMode: false
          }
        }
      })
    }
  })
});

/*============================================================================
  Single Product Slider
==============================================================================*/
theme.singleProductSlider = (function () {
  const $productSliderThumbs = $('.js-single-thumbs'),
      $productSliderMain = $('.js-single-main');

  const settings = {
      prevArrow: $productSliderMain.parent().find('.swiper-button-prev'),
      nextArrow: $productSliderMain.parent().find('.swiper-button-next')
  }

  const singleProductThumbs = new Swiper($productSliderThumbs, {
    lazy: true,
    // Optional parameters
    preventClicks: false,
    preventClicksPropagation: false,
    speed: 800,

    slidesPerView: 4,
    spaceBetween: 10,
    autoHeight: true,

    mousewheel: {
      forceToAxis: true,
    },

    //cssMode: true,
    freeMode: true,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2,
        spaceBetween: 10,
        navigation: false,
        freeMode: false
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 2,
        spaceBetween: 10,
        navigation: false,
        freeMode: false
      },
      // when window width is >= 640px
      640: {
        freeMode: true
      }
    }
  });

  const singleProductMain = new Swiper($productSliderMain, {
    speed: 800,
    lazy: true,
    zoom: true,
    pagination: {
      el: '.swiper-pagination',
    },
    fadeEffect: {
      crossFade: true
    },
    effect: 'fade',

    // Navigation arrows
    navigation: {
      nextEl: settings.nextArrow,
      prevEl: settings.prevArrow,
    },

    thumbs: {
      swiper: singleProductThumbs
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        }
      },
      // when window width is >= 480px
      480: {
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        }
      },
      // when window width is >= 769px
      769: {
        pagination: false
      }
    }

  })
});
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    theme.cache.$body.trigger('beforeDrawerOpen.theme', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    theme.cache.$body.trigger('afterDrawerOpen.theme', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    theme.cache.$body.trigger('beforeDrawerClose.theme', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    theme.cache.$body.trigger('afterDrawerClose.theme', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();


// Initialize Theme's JS on docready
$(theme.init);
